import styled from 'styled-components';
import { TGlobalColors } from '@pb/styles';

import { TAlign, TStyledSectionProperties } from './section.types';

const alignMap = new Map([
    ['left', 'flex-start'],
    ['center', 'center'],
    ['right', 'flex-end'],
]);

export const StyledSection = styled.section<TStyledSectionProperties>`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3.2rem 1.5rem;
    background-color: ${({ backgroundColor, theme }) =>
        theme.color[backgroundColor as TGlobalColors]};
    @media (min-width: ${properties =>
            properties.theme.deprecatedScreen.tabletPortraitMinimum}) {
        padding-top: 4.8rem;
        padding-bottom: 4.8rem;
    }

    @media (min-width: ${properties =>
            properties.theme.deprecatedScreen.tabletLandscapeMinimum}) {
        padding-top: 7.2rem;
        padding-bottom: 7.2rem;
    }
`;

export const StyledContainer = styled.div<TStyledSectionProperties>`
    display: flex;
    flex-direction: column;
    align-items: ${({ align }) =>
        alignMap.get(align as TAlign) ?? 'flex-start'};
    width: 100%;
    max-width: ${({ theme }) => theme.dimensions.maxContentWidth};
    text-align: ${({ textAlign }) => textAlign};
`;
